var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M7 38C7 56.7777 22.2223 72 41 72C59.7777 72 75 56.7777 75 38C75 19.2223 59.7777 4 41 4C22.2223 4 7 19.2223 7 38Z",
    stroke: "#999999",
    strokeWidth: 2.54414,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M75.003 38H68.5547",
    stroke: "#999999",
    strokeWidth: 2.93103,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M14.0342 38H7.58594",
    stroke: "#999999",
    strokeWidth: 2.93103,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M41.293 71.7071V65.2588",
    stroke: "#999999",
    strokeWidth: 2.93103,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M41.293 10.7417V4.29346",
    stroke: "#999999",
    strokeWidth: 2.93103,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M35.7239 32.7239L26.2421 51.6875C25.7301 52.7114 26.8386 53.7868 27.8466 53.244L47.448 42.6894L57.4159 23.7505C57.9519 22.732 56.8525 21.6314 55.8334 22.1664L35.7239 32.7239Z",
    stroke: "#999999",
    strokeWidth: 2.93103,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInduction);
export default __webpack_public_path__ + "static/media/induction.58a9655b002aa3517a880659e16acad2.svg";
export { ForwardRef as ReactComponent };